module.exports = __webpack_public_path__ + "assets/img/KeyReport_004_en.33e22305-ps.jpg";